import { lazy, Suspense } from "react"
import { useLoadedOnMouseMove } from "~/sdk/useUI"
import type { Props } from "~/components/header/menu/mobile"

const Menu = lazy(() => import('~/components/header/menu/mobile'))

export default function MobileMenu(props: Props) {
    const loaded = useLoadedOnMouseMove()

    return <Suspense fallback={null}>{loaded && <Menu {...props} />}</Suspense>
}
